module.exports = __webpack_public_path__ + "img/icon-sb-customize-this-set-48.8354944.svg";